import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useImperativeHandle, useRef} from 'react';
import Fields from './Fields';

const OrderItemForm = forwardRef(({service, order, item, showCommodity = false, onSaved}, ref) => {
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={item}
      type="item"
      fieldsComponent={(props) => <Fields order={order} showCommodity={showCommodity} {...props}/>}
      onSave={(
        {
          material_id,
          format_id,
          other_format,
          colour_id,
          other_colour,
          commodity_code,
          price,
          price_tbc,
          weight
        }
      ) => service.item.saveItem(
        order,
        {
          ...(item?.id ? {id: item.id} : {}),
          material_id,
          ...(format_id === 'O' ? {other_format} : {format_id}),
          ...(colour_id === 'O' ? {other_colour} : {colour_id}),
          ...(showCommodity ? {commodity_code} : {}),
          price,
          price_tbc,
          weight
        }
      )}
      onSaved={onSaved}
    />
  );
});

export default OrderItemForm;
